import React, { Component } from "react";
import { connect } from "react-redux";
import "./style.css";
import { actions as schoolFilterActions } from "../../../../redux/modules/schoolfilter";
import { get } from "../../../../utils/request";
let params = {
  schoolName: "",
  schoolLevelIds: [],
  schoolTagIds: [],
  schoolPropertyIds: [],
  provinceIds: [],
  pageNum: 1,
  pageSize: 20,
};
/**
 * 用于神奇大学的专业搜索
 */
class SchoolKeySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickName: "取消",
      name: "",
      schools: [],
    };
  }

  componentDidUpdate() {
    this.textInput.focus();
  }
  componentDidMount(){
    this.setState({
      clickName: "取消",
      name: this.props.schoolQuery.schoolName,
      schools: [],
    })
  }

  render() {
    const { placeholder, visible } = this.props;
    return (
      <div
        className={
          visible === true
            ? "schoolKeySearch_box"
            : "schoolKeySearch_box display_none"
        }
      >
        <div className="schoolKeySearch_box_left fl">
          <div className="schoolKeySearch_box_left_div">
            <div className="schoolKeySearch_box_left_div_img fl">
              <img
                alt=""
                src={require("../../../../images/search/search_2.png")}
              ></img>
            </div>
            <div className="schoolKeySearch_box_left_div_input fl">
              <input
                value={this.state.name}
                onChange={this.handleChang}
                ref={(input) => {
                  this.textInput = input;
                }}
                placeholder={placeholder}
              ></input>
            </div>
            <div
              style={{
                display: this.state.clickName === "搜索" ? "block" : "none",
              }}
              className="schoolKeySearch_box_right_div_img fr"
              onClick={() => this.handleRemoveName()}
            >
              <img
                alt=""
                src={require("../../../../images/search/search_3.png")}
              ></img>
            </div>
          </div>
        </div>
        <div className="schoolKeySearch_box_right fl">
          <div
            onClick={this.handleSearch}
            className="schoolKeySearch_box_right_txt fl"
          >
            {this.state.clickName}
          </div>
        </div>
        <div className="clear"></div>
        <div className="schoolKeySearch_box_item">
          {this.state.schools.map((item, index) => {
            return (
              <div
                key={index}
                onClick={this.handleClick.bind(this, item)}
                className="schoolKeySearch_item"
              >
                {item}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  /**
   * 搜索查询
   */
  handleSearch = () => {
    params = {
      schoolName: this.state.name,
      pageNum: 1,
      pageSize: 20,
    };
    const { dispatch } = this.props;
    dispatch(schoolFilterActions.setQuerySchoolName(this.state.name))
    setTimeout(() => {
      this.props.handleKeyChangeParams(params);
      if (this.state.clickName === "取消") {
        this.props.requestFilterSchoolList();
        this.props.handleResetHeaderNum();
        this.setState({
          clickName: "取消",
          name: "",
          schools: [],
        });
      } else {
        this.props.requestFilterSchoolList();
      }
      this.props.handleAddScroll();
      this.props.handleVisibleSearch();
      this.props.handleShowDataList();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });
  };
  /**
   * 点击院校
   */
  handleClick = (item) => {
    params = {
      schoolName: item,
      pageNum: 1,
      pageSize: 20,
    };
    this.setState({
      name: item,
    });
    const { dispatch } = this.props;
    dispatch(schoolFilterActions.setQuerySchoolName(item))
    setTimeout(() => {
      this.props.handleKeyChangeParams(params);
      this.props.requestFilterSchoolList();
      this.props.handleVisibleSearch();
      this.props.handleShowDataList();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.getSchools(this.state.name);
    });
  };
  /**
   * input输入框变化的时候
   */
  handleChang = (e) => {
    this.setState({
      name: e.target.value,
    });
    if (e.target.value.length > 0) {
      this.setState({
        clickName: "搜索",
      });
      get("/public/v1/school/search/prompt/" + e.target.value).then((res) => {
        this.setState({
          schools: res.data,
        });
      });
    } else {
      this.setState({
        clickName: "取消",
        schools: [],
      });
    }
  };
  /**
   * 点击院校的时候重新加载
   */
  getSchools = (name) => {
    get("/public/v1/school/search/prompt/" + name).then((res) => {
      this.setState({
        schools: res.data,
      });
    });
  };
  /**
   * 移除搜索的院校名称
   */
  handleRemoveName = () => {
    this.setState({
      clickName: "取消",
      name: "",
      schools: [],
    });
  };
}
const mapStateToProps = (state) => {
  return {
    schoolQuery: state.schoolfilter.schoolQueryData,
  };
};
export default connect(mapStateToProps)(SchoolKeySearch);



// WEBPACK FOOTER //
// ./src/containers/School/components/SchoolKeySearch/index.js